import { render, staticRenderFns } from "./EditChannelViewingSlot.vue?vue&type=template&id=625e974e&"
import script from "./EditChannelViewingSlot.vue?vue&type=script&lang=js&"
export * from "./EditChannelViewingSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports